import { render, staticRenderFns } from "./CutoffPeriodDetail.vue?vue&type=template&id=b8375f62&scoped=true"
import script from "./CutoffPeriodDetail.vue?vue&type=script&lang=js"
export * from "./CutoffPeriodDetail.vue?vue&type=script&lang=js"
import style0 from "./CutoffPeriodDetail.vue?vue&type=style&index=0&id=b8375f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8375f62",
  null
  
)

export default component.exports